import { MODULES } from './modules';

const announcementFields = MODULES.announcements?.fields || [];

const coverField = announcementFields.find((field) => field.key === 'image');
if (coverField) {
  coverField.type = 'image';
  coverField.label = 'Cover photo';
  coverField.hint = 'Optional. Photo select kari upload karo.';
  delete coverField.inputType;
  delete coverField.placeholder;
}

const expiryField = announcementFields.find((field) => field.key === 'expiresAt');
if (expiryField) {
  expiryField.hint = 'Optional. Expiry time pachhi announcement automatic Inactive/Archived thai jashe.';
}
